module.exports = __webpack_public_path__ + "3c11a2d1dd2197f701ed817f0c88b8be.mp3";